import { Typography } from "@mui/material";
import { useCampground } from "@/contexts/AppConfigContext";
import { formatCampgroundAddress } from "@/utils/address";

interface CampgroundHeaderProps {
  variant: "compact" | "expanded";
}

export default function CampgroundHeader({ variant }: CampgroundHeaderProps) {
  const { data: campgroundData } = useCampground();
  const name = campgroundData.campground?.name || "";
  const address = formatCampgroundAddress(campgroundData.campground, campgroundData.countries);

  if (variant === "compact") {
    return (
      <>
        <Typography variant="h3" noWrap>
          {name}
        </Typography>
        <Typography variant="body2" color="text.secondary" noWrap>
          {address.replace(/\n/g, ", ")}
        </Typography>
      </>
    );
  }

  return (
    <>
      <Typography variant="h3" gutterBottom>
        {name}
      </Typography>
      <Typography variant="body2" sx={{ whiteSpace: "pre-wrap", color: "text.secondary" }}>
        {address}
      </Typography>
    </>
  );
}
